(function() {
  var StepHandler,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  StepHandler = App.loadClass('grower::handlers/placement/StepHandler');

  exports.TextboxesHandler = (function(superClass) {
    extend(TextboxesHandler, superClass);

    function TextboxesHandler() {
      return TextboxesHandler.__super__.constructor.apply(this, arguments);
    }

    TextboxesHandler.prototype.inputSel = 'input[type="text"]';

    TextboxesHandler.prototype.addValidationRules = function() {
      this.validator.registerRule({
        selector: '.validate-int',
        text: '%s must be a whole number',
        func: (function(_this) {
          return function(elem) {
            var val;
            val = $(elem).val();
            return !val || (!isNaN(val) && String(parseInt(val)) === val);
          };
        })(this)
      });
      return this.validator.registerRule({
        selector: '.validate-in-range',
        text: '%s must be within an appropriate range',
        func: (function(_this) {
          return function(elem) {
            var max, maxValid, min, minValid, val;
            val = $(elem).val();
            val = (val && !isNaN(val)) ? parseFloat(val) : null;
            if (val == null) {
              return true;
            }
            min = $(elem).attr('data-min');
            min = (min && !isNaN(min)) ? parseFloat(min) : null;
            minValid = (min != null) && val >= min;
            max = $(elem).attr('data-max');
            max = (max && !isNaN(max)) ? parseFloat(max) : null;
            maxValid = (max != null) && val <= max;
            if ((min != null) && (max != null) && !(minValid && maxValid)) {
              _this.validator.rules['.validate-in-range'].text = "%s must be between " + min + " and " + max;
              return false;
            } else if ((min != null) && !minValid) {
              _this.validator.rules['.validate-in-range'].text = "%s must be greater than or equal to " + min;
              return false;
            } else if ((max != null) && !maxValid) {
              _this.validator.rules['.validate-in-range'].text = "%s must be less than or equal to " + max;
              return false;
            } else {
              _this.validator.rules['.validate-in-range'].text = '%s must be within an appropriate range';
              return true;
            }
          };
        })(this)
      });
    };

    TextboxesHandler.prototype.getFieldAspect = function(fieldID, aspectID) {
      var retval, yArray;
      yArray = this.taffyObjects.axes({
        name: 'Y'
      }).select('array')[0];
      if (yArray === 'fields') {
        retval = {
          value: parseInt(this.getInputEl({
            field: fieldID,
            aspect: aspectID
          }).val()) || null
        };
      } else if (yArray === 'y_aspects') {
        retval = {
          value: parseInt(this.getInputEl({
            aspect: aspectID
          }).val()) || null
        };
      }
      return retval;
    };

    TextboxesHandler.prototype.setFieldAspect = function(fieldAspect) {
      var input, ref, yArray;
      yArray = this.taffyObjects.axes({
        name: 'Y'
      }).first().array;
      if (yArray === 'fields') {
        input = this.getInputEl({
          field: fieldAspect.fields_id,
          aspect: fieldAspect.aspects_id
        });
      } else if (yArray === 'y_aspects') {
        input = this.getInputEl({
          aspect: fieldAspect.aspects_id
        });
      }
      return input.val((ref = fieldAspect.value) != null ? ref : '');
    };

    return TextboxesHandler;

  })(StepHandler);

}).call(this);
